/* eslint-disable */
import React from "react";
import { CalendarMonth } from '../../../controls/CalendarMonth';
import { CalendarHierarchy, InputCalendarHierarchyItem } from '../../../controls/CalendarHierarchy';
import { ICalendarItem, useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { equal } from "../../../../../shared";

export const BaseForIndexHierarchyControl: React.FC = () => {
    const [dictItems] = useDictionary(dictionaryService, "calendar-origin");
    const [controlValue, setControlValue] = React.useState<number | undefined>();
    const [controlItems, setControlItems] = React.useState<InputCalendarHierarchyItem[] | undefined>();
    const [calendarValue, setCalendarValue] = useParameter<number>("@base_index");
    const [calendarDisplayValue, setCalendarDisplayValue] = useParameter<number>("@base_index_display");

    React.useEffect(() => {
        const nextControlValue = calendarDisplayValue;
        if (!equal(nextControlValue, controlValue)) {
            setControlValue(nextControlValue!);
        }
    }, [calendarDisplayValue]);

    React.useEffect(() => {
        const candiatesControlItems = dictItems?.map<InputCalendarHierarchyItem & { frequency: number }>(item => ({
            id: Number(item.id),
            parent: item.getValue<number>('parent'),
            name: item.getValue<string>('name') || '',
            frequency: item.getValue<number>('frequencyId')!,
        }));
        
        const [minYear, maxYear] = [120040101, Number(`1${new Date().getFullYear()}0101`)];
        const nextControlItems = candiatesControlItems?.reduce((result, item) => {
            const [yearFrequency, monthFrequency, weekFrequency] = [1, 4, 7];
            const itemId = item.id as number;
            if (item.frequency === yearFrequency && itemId >= minYear && itemId <= maxYear) {
                result.push(item);
            } else if (item.frequency === monthFrequency) {
                const paretQuartal = dictItems?.find(dictItem => equal(+dictItem.id, item.parent));
                const parentYearId = paretQuartal?.getValue<number>('parent')!;
                if (parentYearId >= minYear && parentYearId <= maxYear) {
                    item.parent = parentYearId;
                    result.push(item);
                }
            } else if (item.frequency === weekFrequency) {
                const paretMonth = result?.find(resultItem => equal(Number(resultItem.id), item.parent));
                if (paretMonth) {
                    result.push(item);
                }
            }
            return result;
        }, [] as typeof candiatesControlItems);

        setControlItems(nextControlItems);
    }, [JSON.stringify(dictItems)]);



    const handlerChange = React.useCallback((value: unknown) => {
        const weekOrMonthOrYearId = value as number;
        setCalendarDisplayValue(weekOrMonthOrYearId);
        const [weekFrequency] = [7];
        const week = dictItems?.find(item => {
            const itemFrequency = item.getValue<number>("frequencyId");
            const isWeek = itemFrequency === weekFrequency;
            if (isWeek) {
                if (weekOrMonthOrYearId === Number(item.id)) {
                    return true;
                }
                const monthParentId = item.getValue<number>("parent")!;
                const monthParent = dictItems.find(item => +item.id === monthParentId)!;
                const quartalParent = dictItems.find(item => +item.id === monthParent.getValue<number>("parent"))!;
                const yearParentId = quartalParent.getValue<number>("parent")!;
                return weekOrMonthOrYearId === monthParentId || weekOrMonthOrYearId === yearParentId;
            }
            return false;
        });
        const weekId = Number(week?.id);
        if (weekId) {
            setCalendarValue(weekId);
        }
    }, [dictItems]);

    return <CalendarHierarchy selectableParent label="Base for index" value={controlValue} onChange={handlerChange} items={controlItems} />;
};
